import { useState } from "react";
import { useRequest, useInterval } from "ahooks";
import { Card, Tag } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { announcement as announcementService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function AnnouncementCard() {
  const [version, setVersion] = useState(Date.now());
  const auth = useAuthContext();
  useInterval(() => {
    setVersion(Date.now());
  }, 30000);
  const { data = { total: 0, results: [] } } = useRequest(
    () => {
      return announcementService.listMyReceiveAnnouncement(
        { page: 1, page_size: 10 },
        auth.token
      );
    },
    {
      ready: !!auth?.token,
      refreshDeps: [version, auth?.token],
    }
  );

  const items = data.results.map((i) => (
    <li key={`anno-${i.id}`} className="message-item bolder">
      <div className="message-dot"> · </div>
      <div className="message-label">
        <Link to={`/workshop/announce/detail/${i.id}`}>
          &lt; {i.type_name} &gt;
          {i.title}
        </Link>
      </div>
      {/* <div className="message-newer">
        {i.records.find((r) => r.department.id === auth.department_id)
          ?.is_read === false && <Tag color="red">New</Tag>}
      </div> */}
      <div className="message-date">{moment(i.published_at).format("M-D")}</div>
    </li>
  ));
  return (
    <Card
      title="公告栏"
      size="small"
      headStyle={{
        backgroundColor: "#1e87fb",
        color: "#fff",
        fontFamily: "Microsoft YaHei-Bold",
        fontWeight: "bold",
        fontSize: 18,
      }}
      bodyStyle={{ padding: 0 }}
      extra={
        <Link to="/workshop/announce/0" className="ant-btn ant-btn-primary">
          查看更多
        </Link>
      }
    >
      <ul className="message-list" style={{ minHeight: 430 }}>
        {items}
      </ul>
    </Card>
  );
}

export default AnnouncementCard;
